'use client';

import { useState, useEffect } from 'react';

var useCountdown = function (expireDate) {
    var _a = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }), times = _a[0], setTimes = _a[1];
    useEffect(function () {
        var interval = setInterval(function () {
            var now = new Date();
            var targetDate = new Date(expireDate);
            var timeDifference = targetDate.getTime() - now.getTime();
            var seconds = Math.max(0, Math.floor(timeDifference / 1000));
            var minutes = Math.max(0, Math.floor(seconds / 60));
            var hours = Math.max(0, Math.floor(minutes / 60));
            var days = Math.max(0, Math.floor(hours / 24));
            var remainingSeconds = seconds % 60;
            var remainingMinutes = minutes % 60;
            var remainingHours = hours % 24;
            setTimes({
                days: days,
                hours: remainingHours,
                minutes: remainingMinutes,
                seconds: remainingSeconds
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [expireDate]);
    return { times: times };
};

export { useCountdown as default };
//# sourceMappingURL=useCountdown.js.map
